/* eslint-disable no-console */
/* eslint-disable react/prop-types */
import React, { useState, useEffect, useRef, useContext } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Container from 'react-bootstrap/Container';
import { useHistory, Link } from 'react-router-dom';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import { toast } from 'react-toastify';
import NavDropdown from 'react-bootstrap/NavDropdown';
import Offcanvas from 'react-bootstrap/Offcanvas';
import { Modal } from 'react-bootstrap';
import {
  cartItemReset,
  getCartAction,
  getUserCartAction,
  newCartAction,
} from '../reducers/cartItemData';
import { userLogoutAction } from '../reducers/userSession';
import { DataLayerLogoutEvent } from './dataLayerUserEvent';
import Notification from '../components/notification/notification';
import {
  currentMessageAction,
  notificationClickAction,
  notificationViewAction,
} from '../reducers/notification';
import findAllSubscribedCalls from '../API/callsAPI';
import { decryptData, encryptData } from './dataEncryptDecrypt';
import { destroyOneSession } from '../API/sessionsAPI';
import { NotificationContext } from './notificationContext';

function TopNavBar(props) {
  const { activeScreen, activeNavTab } = props;
  const userStoreSession = useSelector(
    (state) => state.UserSessionReducer.userSessionStoreData
  );
  const userStoreToken = useSelector(
    (state) => state.UserSessionReducer.userTokenStoreData
  );
  const userStoreSessionId = useSelector(
    (state) => state.UserSessionReducer.userSessionIdStoreData
  );
  const dispatch = useDispatch();
  const cartItemDataFromStore = useSelector(
    (state) => state.CartItemReducer.cartItems
  );
  const history = useHistory();
  const [btnStatus, setBtnStatus] = useState(
    activeNavTab !== undefined ? activeNavTab : 'home'
  );
  const [show, setShow] = useState(false);
  const handleShow = () => setShow(true);
  const handleClose = () => setShow(false);
  const [floatStatus, setFloatStatus] = useState(false);
  const [logoutPopup, setLogoutPopup] = useState(false);
  const { notificationPopupClick, handleNotificationCloseClick } =
    useContext(NotificationContext);
  const [notificationPopup, setNotificationPopup] = useState(false);

  const getOneCart = async () => {
    if (userStoreSession != null) {
      dispatch(getUserCartAction(userStoreToken));
    } else if (cartItemDataFromStore.length !== 0) {
      const { orderUID } = cartItemDataFromStore;
      dispatch(getCartAction({ orderUID }));
    } else if (cartItemDataFromStore.length === 0) {
      dispatch(newCartAction());
    }
  };

  const logoutHandle = () => {
    const eventData = {
      user_id: userStoreSession.userUID,
      method: 'Logout',
      Name: userStoreSession.name,
      Email: userStoreSession.email,
      Phone: userStoreSession.mobile,
    };
    if (userStoreSessionId != null) {
      destroyOneSession({ sessionUID: userStoreSessionId }).then((res) => {
        if (res.data.success === true) {
          toast.success(res.data.message);
        }
      });
    }
    DataLayerLogoutEvent(eventData);
    dispatch(userLogoutAction());
    dispatch(cartItemReset());
    setLogoutPopup(false);
    history.push('/login');
  };

  const notificationRef = useRef(null);
  const notificationPanelRef = useRef(null);
  const notificationMobilePanelRef = useRef(null);

  const cleanUpLocalStorage = (messages) => {
    const encryptedData = localStorage.getItem('readMessages');
    const savedReadMessages = encryptedData ? decryptData(encryptedData) : [];
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const updatedReadMessages = savedReadMessages.filter((messageUID) => {
      const message = messages.find((item) => item.messageUID === messageUID);
      if (message) {
        const messageDate = new Date(message.createdAt);
        messageDate.setHours(0, 0, 0, 0); // Reset time to midnight
        return messageDate >= today;
      }
      return false;
    });
    const encryptedDataForStore = encryptData(updatedReadMessages);
    localStorage.setItem('readMessages', encryptedDataForStore);
  };

  const getAllMessages = async () => {
    try {
      if (userStoreSession) {
        const userToken = userStoreToken;
        const userSessionId = userStoreSessionId;
        const res = await findAllSubscribedCalls(userToken, userSessionId);
        const allMessages = res.data.calls.flatMap((call) => call.messages);
        allMessages.sort(
          (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
        );
        cleanUpLocalStorage(allMessages);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getOneCart();
    getAllMessages();
    if (notificationPopupClick) {
      setNotificationPopup(true);
    }
  }, [notificationPopupClick]);

  return (
    <Navbar
      expand
      style={{
        backgroundColor: '#ffffff',
        boxShadow: '0px 0px 4px 0px rgba(0, 0, 0, 0.25)',
      }}
      variant='dark'
    >
      <Nav className='d-sm-flex d-md-flex d-lg-none align-items-center'>
        <Nav.Link className='pe-0'>
          <i
            className='bi bi-list int-text-darkgray fs-3'
            onClick={handleShow}
            aria-hidden
          />
        </Nav.Link>
      </Nav>
      <Container className='mx-2 px-lg-2 p-0' fluid>
        <Navbar.Brand onClick={() => history.push('/')}>
          {activeScreen !== '/my-cart' ? (
            <img
              src='../images/logoDark.webp'
              height='40'
              className='d-inline-block align-top'
              alt='intelisys logo'
            />
          ) : (
            <div>
              <div className='d-flex align-items-end d-lg-none int-text-gray'>
                <i className='bi bi-house-fill fs-3 me-2' />
                <h6>Home</h6>
              </div>
              <img
                src='../images/logoDark.webp'
                height='40'
                className='d-inline-block align-top d-none d-lg-inline'
                alt='intelisys logo'
              />
            </div>
          )}
        </Navbar.Brand>
        <Nav className='d-none d-lg-flex'>
          <Nav.Link
            className='mx-3'
            style={{ color: btnStatus === 'home' ? '#3C86DD' : '#9C9C9C' }}
            onClick={() => {
              setBtnStatus('home');
              history.push('/');
            }}
          >
            Home
          </Nav.Link>
          {userStoreSession == null && (
            <Nav.Link
              className='mx-3'
              style={{
                color: btnStatus === 'discoverPlans' ? '#3C86DD' : '#9C9C9C',
              }}
              onClick={() => {
                setBtnStatus('discoverPlans');
                history.push('/view-all-plans');
              }}
            >
              Discover Plans
            </Nav.Link>
          )}
          {userStoreSession == null && (
            <NavDropdown
              className='mx-3'
              id='collasible-nav-dropdown'
              title={
                <span
                  style={{
                    color:
                      btnStatus === 'buysinglecall' ||
                      btnStatus === 'buyanalisys'
                        ? '#3C86DD'
                        : '#9C9C9C',
                  }}
                >
                  Today&apos;s Pick
                </span>
              }
            >
              <NavDropdown.Item
                style={{
                  color: btnStatus === 'buysinglecall' ? '#3C86DD' : '#9C9C9C',
                }}
                onClick={() => {
                  setBtnStatus('buysinglecall');
                  history.push('/calls');
                }}
              >
                Buy Live Single Call
              </NavDropdown.Item>
              <NavDropdown.Divider />
              <NavDropdown.Item
                style={{
                  color: btnStatus === 'buyanalisys' ? '#3C86DD' : '#9C9C9C',
                }}
                onClick={() => {
                  setBtnStatus('buyanalisys');
                  history.push('/analysis');
                }}
              >
                Buy Live Single Analysis
              </NavDropdown.Item>
            </NavDropdown>
          )}

          {userStoreSession !== null && (
            <Nav.Link
              className='me-3'
              style={{
                color: btnStatus === 'dashboard' ? '#3C86DD' : '#9C9C9C',
              }}
              onClick={() => {
                setBtnStatus('dashboard');
                localStorage.setItem('activeScreen', 'TriggerCall');
                history.push('/dashboard');
              }}
            >
              My Dashboard
            </Nav.Link>
          )}

          {userStoreSession !== null && (
            <Nav.Link
              className='me-4'
              style={{
                color: btnStatus === 'refer-and-earn' ? '#3C86DD' : '#9C9C9C',
              }}
              onClick={() => {
                setBtnStatus('refer-and-earn');
                history.push('/refer-and-earn');
              }}
            >
              Refer & Earn
            </Nav.Link>
          )}

          {userStoreSession !== null ? (
            <>
              {userStoreSession.profilePicture !== null && (
                <img
                  src={userStoreSession.profilePicture}
                  className='img-fluid text-center rounded-circle border-2 border'
                  alt=''
                  style={{ width: 40, height: 40 }}
                />
              )}
              {userStoreSession.profilePicture == null && (
                <i
                  className='bi bi-person-circle fs-3 m-auto'
                  style={{
                    color: btnStatus === 'profile' ? '#3C86DD' : '#9C9C9C',
                  }}
                />
              )}
              <NavDropdown
                title={
                  <span
                    style={{
                      color: btnStatus === 'profile' ? '#3C86DD' : '#9C9C9C',
                    }}
                  >
                    {userStoreSession.email || userStoreSession.mobile}
                  </span>
                }
                id='collasible-nav-dropdown'
              >
                <NavDropdown.Item
                  style={{
                    color: btnStatus === 'profile' ? '#3C86DD' : '#9C9C9C',
                  }}
                  onClick={() => {
                    setBtnStatus('profile');
                    history.push('/profile');
                    localStorage.setItem('profileButton', 'myProfile');
                  }}
                >
                  My Profile
                </NavDropdown.Item>
                <NavDropdown.Item
                  onClick={() => setLogoutPopup(true)}
                  style={{ color: '#9C9C9C' }}
                >
                  Logout
                </NavDropdown.Item>
              </NavDropdown>
            </>
          ) : (
            <Nav.Link
              className='mx-3'
              style={{
                color: '#9C9C9C',
              }}
              onClick={() => history.push('/login')}
            >
              Login
            </Nav.Link>
          )}
          {userStoreSession != null && (
            <Nav.Link
              className='mx-3 btn position-relative rounded-circle'
              style={{
                border: notificationPopup
                  ? '1px solid #3C86DD'
                  : '1px solid #9C9C9C',
              }}
              ref={notificationRef}
              onClick={() => {
                setNotificationPopup(!notificationPopup);
                dispatch(notificationClickAction(null));
                dispatch(notificationViewAction(true));
                dispatch(currentMessageAction(null));
              }}
            >
              {notificationPopup ? (
                <i
                  className='bi bi-bell-fill mx-1'
                  style={{ color: '#3C86DD' }}
                />
              ) : (
                <i className='bi bi-bell mx-1' style={{ color: '#9C9C9C' }} />
              )}
            </Nav.Link>
          )}

          <Nav.Link
            className='mx-3 btn position-relative rounded-circle'
            style={{
              border:
                activeScreen === '/my-cart'
                  ? '1px solid #3C86DD'
                  : '1px solid #9C9C9C',
            }}
            onClick={() => {
              history.push('/my-cart');
              setBtnStatus('my-cart');
            }}
          >
            {activeScreen !== '/my-cart' ? (
              <i className='bi bi-cart mx-1' style={{ color: '#9C9C9C' }} />
            ) : (
              <i
                className='bi bi-cart-fill mx-1 text-primary'
                style={{ color: '#3C86DD' }}
              />
            )}
            {cartItemDataFromStore &&
              cartItemDataFromStore.lineItems &&
              cartItemDataFromStore.lineItems.length !== 0 && (
                <span className='position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger'>
                  {cartItemDataFromStore.lineItems.length}
                </span>
              )}
          </Nav.Link>
        </Nav>
        <Nav className='d-sm-flex d-md-flex d-lg-none align-items-center'>
          {userStoreSession !== null && btnStatus !== 'dashboard' && (
            <Nav.Link
              className='text-nowrap fs-5'
              onClick={() => {
                setBtnStatus('dashboard');
                localStorage.setItem('activeScreen', 'TriggerCall');
                history.push('/dashboard');
              }}
            >
              <div className='d-flex align-items-center'>
                <i className='bi bi-columns-gap me-2 int-text-lightgray' />
                <span className='fs-6 int-text-lightgray'>Dashboard</span>
              </div>
            </Nav.Link>
          )}
          {userStoreSession != null && (
            <Nav.Link
              className='mx-2 btn position-relative rounded-circle'
              style={{
                border: notificationPopup
                  ? '1px solid #3C86DD'
                  : '1px solid #9C9C9C',
              }}
              ref={notificationMobilePanelRef}
              onClick={() => {
                setNotificationPopup(!notificationPopup);
                dispatch(notificationClickAction(null));
                dispatch(notificationViewAction(true));
                dispatch(currentMessageAction(null));
              }}
            >
              {notificationPopup ? (
                <i
                  className='bi bi-bell-fill mx-1'
                  style={{ color: '#3C86DD' }}
                />
              ) : (
                <i className='bi bi-bell mx-1' style={{ color: '#9C9C9C' }} />
              )}
            </Nav.Link>
          )}
          {activeScreen !== '/my-cart' && userStoreSession == null && (
            <Nav.Link
              className='mx-2 btn position-relative rounded-circle'
              style={{
                border:
                  activeScreen === '/my-cart'
                    ? '1px solid #3C86DD'
                    : '1px solid #9C9C9C',
              }}
              onClick={() => {
                setBtnStatus('my-cart');
                history.push('/my-cart');
              }}
            >
              <i className='bi bi-cart mx-1 int-text-gray' />
              {cartItemDataFromStore &&
                cartItemDataFromStore.lineItems &&
                cartItemDataFromStore.lineItems.length !== 0 && (
                  <span className='position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger'>
                    {cartItemDataFromStore.lineItems.length}
                  </span>
                )}
            </Nav.Link>
          )}
          {activeScreen !== '/my-cart' && userStoreSession == null && (
            <Nav.Link
              className='btn position-relative'
              onClick={() => history.push('/login')}
            >
              <span className='int-text-gray'>Login</span>
            </Nav.Link>
          )}
        </Nav>
      </Container>
      <Offcanvas
        style={{ backgroundColor: '#FFFFFF' }}
        show={show}
        onHide={handleClose}
      >
        <Offcanvas.Header closeButton className='bg-white p-0 px-3 p-1 pt-3'>
          <Offcanvas.Title>
            <img
              src='../images/LogoBlue.webp'
              className='img-fluid'
              style={{ width: '150px' }}
              alt='Logo'
            />
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body className='p-0'>
          <Nav>
            <div className='border border-2 mt-2' />

            <div className='d-flex flex-column'>
              <Nav.Link
                onClick={() => {
                  setBtnStatus('home');
                  history.push('/');
                  handleClose();
                }}
                className='d-flex align-items-center ps-2'
              >
                <i className='bi bi-house fs-6 ps-2 text-dark' />
                <button
                  type='button'
                  style={{
                    color: btnStatus === 'home' ? '#0D94FB' : '#777777',
                  }}
                  className='btn fs-4'
                >
                  Home
                </button>
              </Nav.Link>
              <div className='border border-2' />

              {userStoreSession != null && (
                <div>
                  <Nav.Link
                    className='mt-2 d-flex align-items-center ps-2'
                    onClick={() => {
                      setBtnStatus('dashboard');
                      localStorage.setItem('activeScreen', 'TriggerCall');
                      history.push('/dashboard');
                      handleClose();
                    }}
                  >
                    <i className='bi bi-columns-gap fs-6 ps-2 text-dark' />
                    <button
                      type='button'
                      style={{
                        color:
                          btnStatus === 'dashboard' ? '#0D94FB' : '#777777',
                      }}
                      className='btn fs-4'
                    >
                      Dashboard
                    </button>
                  </Nav.Link>
                  <div className='border border-2 mt-2' />
                </div>
              )}

              <Nav.Link
                className='d-flex align-items-center justify-content-between ps-2'
                onClick={() => {
                  setBtnStatus('my-cart');
                  history.push('/my-cart');
                  handleClose();
                }}
              >
                <div className='d-flex align-items-center'>
                  <i className='bi bi-cart fs-6 ps-2 text-dark' />
                  <button
                    type='button'
                    style={{
                      color:
                        activeScreen === '/my-cart' ? '#0D94FB' : '#777777',
                    }}
                    className='btn fs-4'
                  >
                    Cart
                  </button>
                </div>
                {cartItemDataFromStore &&
                  cartItemDataFromStore.lineItems &&
                  cartItemDataFromStore.lineItems.length !== 0 && (
                    <span className='badge rounded-pill bg-danger me-2'>
                      {cartItemDataFromStore.lineItems.length}
                    </span>
                  )}
              </Nav.Link>
              <div className='border border-2' />

              {userStoreSession == null && (
                <div>
                  <Nav.Link
                    className='d-flex align-items-center ps-2'
                    onClick={() => {
                      setBtnStatus('discoverPlans');
                      history.push('/view-all-plans');
                    }}
                  >
                    <i className='bi bi-search fs-6 ps-2 text-dark' />
                    <button
                      type='button'
                      style={{
                        color:
                          btnStatus === 'discoverPlans' ? '#0D94FB' : '#777777',
                      }}
                      className='btn fs-4'
                    >
                      Discover Plans
                    </button>
                  </Nav.Link>
                  <div className='border border-2' />
                </div>
              )}

              {userStoreSession != null && (
                <div>
                  <Nav.Link
                    className='d-flex align-items-center ps-2'
                    onClick={() => {
                      setBtnStatus('refer-and-earn');
                      localStorage.setItem('activeScreen', 'TriggerCall');
                      history.push('/refer-and-earn');
                      handleClose();
                    }}
                  >
                    <i className='bi bi-currency-rupee fs-6 ps-2 text-dark' />
                    <button
                      type='button'
                      style={{
                        color:
                          btnStatus === 'refer-and-earn'
                            ? '#0D94FB'
                            : '#777777',
                      }}
                      className='btn fs-4'
                    >
                      Refer & Earn
                    </button>
                  </Nav.Link>
                  <div className='border border-2 mt-2' />
                </div>
              )}

              {userStoreSession == null && (
                <div>
                  <h4 className='d-flex justify-content-between align-items-center p-3 pb-0'>
                    Today&apos;s Pick
                  </h4>
                </div>
              )}

              {userStoreSession == null && (
                <div>
                  <Nav.Link
                    className='d-flex align-items-center ps-2'
                    onClick={() => {
                      setBtnStatus('buysinglecall');
                      history.push('/calls');
                    }}
                  >
                    <i className='bi bi-graph-up fs-6 ps-2 text-dark' />
                    <button
                      type='button'
                      className='btn fs-4'
                      style={{
                        color:
                          btnStatus === 'buysinglecall' ? '#0D94FB' : '#777777',
                      }}
                    >
                      Buy Live Single Call
                    </button>
                  </Nav.Link>
                  <div className='border border-2' />
                </div>
              )}

              {userStoreSession == null && (
                <div>
                  <Nav.Link
                    className='d-flex align-items-center ps-2'
                    onClick={() => {
                      setBtnStatus('buyanalisys');
                      history.push('/analysis');
                    }}
                  >
                    <i className='bi bi-bar-chart-steps fs-6 ps-2 text-dark' />
                    <button
                      type='button'
                      style={{
                        color:
                          btnStatus === 'buyanalisys' ? '#0D94FB' : '#777777',
                      }}
                      className='btn fs-4'
                    >
                      Buy Live Single Analysis
                    </button>
                  </Nav.Link>
                  <div className='border border-2' />
                </div>
              )}

              {userStoreSession != null && (
                <div>
                  <Nav.Link
                    className='d-flex align-items-center ps-2'
                    onClick={() => {
                      setBtnStatus('profile');
                      history.push('/profile');
                      handleClose();
                    }}
                  >
                    <i className='bi bi-person fs-5 ps-2 text-dark' />
                    <button
                      type='button'
                      style={{
                        color: btnStatus === 'profile' ? '#0D94FB' : '#777777',
                      }}
                      className='btn fs-4'
                    >
                      Profile
                    </button>
                  </Nav.Link>
                  <div className='border border-2' />
                </div>
              )}

              {userStoreSession == null && (
                <div>
                  <div className='p-2 d-flex justify-content-between align-items-center ps-2'>
                    <button
                      type='button'
                      onClick={() => history.push('/login')}
                      className='btn btn-hover fs-4 int-text ps-0'
                    >
                      Click here to login
                    </button>
                    <i className='bi bi-door-open int-text fs-6 pe-2 text-dark' />
                  </div>
                  <div className='border border-2' />
                </div>
              )}

              {userStoreSession != null && (
                <div
                  style={{
                    position: 'absolute',
                    bottom: 0,
                    padding: '10px 0',
                    left: 0,
                  }}
                  className='mt-2 w-100 d-flex justify-content-between align-items-center'
                >
                  <div className='col-12'>
                    <div className='border border-2 w-100' />
                    <button
                      type='button'
                      onClick={() => setLogoutPopup(true)}
                      className='btn btn-hover ms-2 fs-4 text-danger'
                    >
                      Logout
                    </button>
                  </div>
                </div>
              )}
            </div>
          </Nav>
        </Offcanvas.Body>
      </Offcanvas>
      {floatStatus && (
        <div>
          {activeScreen !== '/my-cart' && (
            <Link to='/my-cart' className='float-cart'>
              <i className='bi bi-cart' />
              {cartItemDataFromStore &&
                cartItemDataFromStore.lineItems &&
                cartItemDataFromStore.lineItems.length !== 0 && (
                  <span
                    className='position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger'
                    style={{ fontSize: '0.5em' }}
                  >
                    {cartItemDataFromStore.lineItems.length}
                  </span>
                )}
            </Link>
          )}
          <a
            href='https://wa.me/918530587555'
            className='float-whatsApp'
            target='_blank'
            rel='noreferrer'
          >
            <i className='bi bi-whatsapp' />
          </a>
        </div>
      )}

      <button
        type='button'
        onClick={() => setFloatStatus(!floatStatus)}
        className='float-menu int-bg'
      >
        <i
          className={`bi ${
            floatStatus ? 'bi-x' : 'bi-plus pmd-btn-fab pmd-ripple-effect'
          } `}
        />
      </button>

      <Modal
        aria-labelledby='example-modal-sizes-title-sm contained-modal-title-vcenter'
        centered
        show={logoutPopup}
        onHide={() => setLogoutPopup(false)}
      >
        <div className='p-3 border-1 shadow-sm border rounded border-secondary'>
          <h4 className='text-primary fw-semibold'>
            Are you sure you want to Logout?
          </h4>
          <h6 className='mt-3 text-secondary'>
            Logging out will terminate your current session.
          </h6>
          <div className='d-flex justify-content-end mt-5'>
            <button
              type='button'
              onClick={() => setLogoutPopup(false)}
              className='btn btn-outline-primary'
            >
              Cancel
            </button>
            <button
              type='button'
              onClick={() => logoutHandle()}
              className='btn btn-danger ms-3'
            >
              <i className='bi bi-box-arrow-right' /> Logout
            </button>
          </div>
        </div>
      </Modal>
      {notificationPopup && (
        <div className='notification shadow rounded' ref={notificationPanelRef}>
          <Notification
            setNotificationPopup={setNotificationPopup}
            notificationPopup={notificationPopup}
            handleNotificationCloseClick={handleNotificationCloseClick}
          />
        </div>
      )}
    </Navbar>
  );
}

export default TopNavBar;
